import axios from 'axios'
import { identify } from '@chordcommerce/chord-js-autonomy/dist/analytics/utils'
import storage from '~/services/storage'

const TRANSACTIONAL_NUMBER_STORAGE = 'maker-attn-transactional-number'

export const detectTransactionalNumber = () =>
  !!storage.getItem(TRANSACTIONAL_NUMBER_STORAGE)

export const subscribeTransactionalNumber = async (emailAddress) => {
  const phoneNumber = storage.getItem(TRANSACTIONAL_NUMBER_STORAGE)

  if (!phoneNumber || !emailAddress) return

  // @see ~/functions/attentive.mjs
  axios
    .get('/.netlify/functions/attentive', {
      params: { emailAddress, phoneNumber },
    })
    .then((response) => {
      if (response.status < 300) {
        // Ensures the order is only reported once.
        storage.removeItem(TRANSACTIONAL_NUMBER_STORAGE)

        const formattedNumber = response?.data?.formattedNumber
        if (formattedNumber) {
          identify('', {
            $phone_number: formattedNumber,
            sms_transactional_opted_in: true,
          })
        }
      } else {
        throw new Error('Attentive function failed')
      }
    })
    .catch((error) => {
      console.error(error, {
        source: 'attentive.client.subscribeTransactionalNumber',
      })
    })
}

export const storeTransactionalNumber = (phoneNumber) => {
  if (!process.env.GATSBY_ATTENTIVE_API_KEY) return

  if (phoneNumber) {
    storage.setItem(TRANSACTIONAL_NUMBER_STORAGE, phoneNumber)
  }
}
